var _g, _circle, _circle2, _circle3, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCommentedPostsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 178,
    viewBox: "0 0 186 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2720"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_d_5329_2559)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5329_2559",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 30.3574C22.804 30.3574 4 49.1615 4 72.3574V111.357C4 134.553 22.804 153.357 46 153.357H71.992C72.7006 153.357 73.3002 153.849 73.6354 154.473L82.5951 171.156C84.4815 174.668 89.5185 174.668 91.4049 171.156L100.365 154.473C100.7 153.849 101.299 153.357 102.008 153.357H128C151.196 153.357 170 134.553 170 111.357V72.3574C170 49.1615 151.196 30.3574 128 30.3574H46Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 30.3574C22.804 30.3574 4 49.1615 4 72.3574V111.357C4 134.553 22.804 153.357 46 153.357H71.992C72.7006 153.357 73.3002 153.849 73.6354 154.473L82.5951 171.156C84.4815 174.668 89.5185 174.668 91.4049 171.156L100.365 154.473C100.7 153.849 101.299 153.357 102.008 153.357H128C151.196 153.357 170 134.553 170 111.357V72.3574C170 49.1615 151.196 30.3574 128 30.3574H46Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 30.3574C22.804 30.3574 4 49.1615 4 72.3574V111.357C4 134.553 22.804 153.357 46 153.357H71.992C72.7006 153.357 73.3002 153.849 73.6354 154.473L82.5951 171.156C84.4815 174.668 89.5185 174.668 91.4049 171.156L100.365 154.473C100.7 153.849 101.299 153.357 102.008 153.357H128C151.196 153.357 170 134.553 170 111.357V72.3574C170 49.1615 151.196 30.3574 128 30.3574H46Z",
    fill: "url(#paint0_linear_5329_2559)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5951 171.156L83.4761 170.683L82.5951 171.156ZM91.4049 171.156L92.2859 171.629L91.4049 171.156ZM5 72.3574C5 49.7137 23.3563 31.3574 46 31.3574V29.3574C22.2518 29.3574 3 48.6092 3 72.3574H5ZM5 111.357V72.3574H3V111.357H5ZM46 152.357C23.3563 152.357 5 134.001 5 111.357H3C3 135.106 22.2518 154.357 46 154.357V152.357ZM71.992 152.357H46V154.357H71.992V152.357ZM83.4761 170.683L74.5164 154L72.7544 154.946L81.7141 171.629L83.4761 170.683ZM90.5239 170.683C89.0148 173.492 84.9852 173.492 83.4761 170.683L81.7141 171.629C83.9778 175.844 90.0222 175.844 92.2859 171.629L90.5239 170.683ZM99.4836 154L90.5239 170.683L92.2859 171.629L101.246 154.946L99.4836 154ZM128 152.357H102.008V154.357H128V152.357ZM169 111.357C169 134.001 150.644 152.357 128 152.357V154.357C151.748 154.357 171 135.106 171 111.357H169ZM169 72.3574V111.357H171V72.3574H169ZM128 31.3574C150.644 31.3574 169 49.7137 169 72.3574H171C171 48.6092 151.748 29.3574 128 29.3574V31.3574ZM46 31.3574H128V29.3574H46V31.3574ZM101.246 154.946C101.472 154.525 101.787 154.357 102.008 154.357V152.357C100.812 152.357 99.9281 153.172 99.4836 154L101.246 154.946ZM71.992 154.357C72.2127 154.357 72.5284 154.525 72.7544 154.946L74.5164 154C74.0719 153.172 73.1884 152.357 71.992 152.357V154.357Z",
    fill: "white",
    mask: "url(#path-1-inside-1_5329_2559)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 249",
    cx: 52,
    cy: 96.3574,
    r: 7,
    fill: "#4C95FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 250",
    cx: 87,
    cy: 96.3574,
    r: 7,
    fill: "#4C95FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 251",
    cx: 122,
    cy: 96.3574,
    r: 7,
    fill: "#4C95FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2617"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 106,
    y: -1.64258,
    width: 80,
    height: 82
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5329_2559_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 247",
    filter: "url(#filter1_d_5329_2559)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 38.3574,
    r: 36,
    fill: "url(#paint1_linear_5329_2559)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 2434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.16 21.531C158.725 19.9662 161.262 19.9662 162.826 21.531C164.391 23.0957 164.391 25.6327 162.826 27.1974L151.666 38.3574L162.826 49.5174C164.391 51.0822 164.391 53.6191 162.826 55.1839C161.262 56.7486 158.725 56.7486 157.16 55.1839L146 44.0239L134.84 55.1839C133.275 56.7486 130.738 56.7486 129.174 55.1839C127.609 53.6191 127.609 51.0822 129.174 49.5174L140.334 38.3574L129.174 27.1974C127.609 25.6327 127.609 23.0957 129.174 21.531C130.738 19.9662 133.275 19.9662 134.84 21.531L146 32.691L157.16 21.531Z",
    fill: "#4C95FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5329_2559",
    x: 0,
    y: 26.3574,
    width: 174,
    height: 151.433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5329_2559",
    x: 106,
    y: -1.64258,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5329_2559_clip_path",
    transform: "translate(-106 1.64258)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 38.3574,
    r: 36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5329_2559",
    x1: 87,
    y1: 30.3574,
    x2: 87,
    y2: 180.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5329_2559",
    x1: 110,
    y1: 32.3574,
    x2: 186.5,
    y2: 55.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCommentedPostsIllustration);
export default __webpack_public_path__ + "static/media/noCommentedPostsIllustration.8e41bf039d496c0b3af889052fd52d11.svg";
export { ForwardRef as ReactComponent };